import { Availability } from './availability';

export class AvailabilityRequest {

    availabilities: Availability[];
    isProviderManager = true;
}
